import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { AgentActivity } from "../types";

interface AgentState {
    agentId: string;
    agentName: string;
    agentTools: string[];
    activity: AgentActivity | undefined;
    activityUpdatedAt?: number;
    pendingActivity: AgentActivity | undefined;
}

interface AgentActions {
    setAgentTools: (tools: string[]) => void;
    setAgentActivity: (activity: AgentActivity, activityUpdatedAt?: number) => void;
    setPendingActivity: (activity: AgentActivity | undefined) => void;
    initAgent: (id: string, name: string, activity: AgentActivity | undefined, activityUpdatedAt: number) => void;
}

export type AgentStore = AgentState & AgentActions;

export const useAgentStore = create<AgentStore>()(
    devtools(
        (set) => ({
            // Initial state values
            agentId: "---", // fallback value
            agentName: "Agent", // fallback value
            agentTools: [],
            activity: undefined,
            pendingActivity: undefined,
            activityUpdatedAt: undefined,

            // Actions
            setAgentActivity: (activity: AgentActivity, activityUpdatedAt?: number) => {
                set(
                    {
                        activity,
                        ...(activityUpdatedAt != null && { activityUpdatedAt }),
                    },
                    false,
                    "setAgentActivity",
                );
            },

            setPendingActivity: (activity?: AgentActivity) => {
                set(
                    {
                        pendingActivity: activity,
                    },
                    false,
                    "setPendingActivity",
                );
            },

            setAgentTools: (tools: string[]) => {
                set(
                    {
                        agentTools: tools,
                    },
                    false,
                    "setAgentTools",
                );
            },

            initAgent: (id: string, name: string, activity: AgentActivity, activityUpdatedAt: number) => {
                set(
                    {
                        agentId: id,
                        agentName: name,
                        activity,
                        activityUpdatedAt,
                    },
                    false,
                    "initAgent",
                );
            },
        }),
        { enabled: import.meta.env.VITE_ENV_TYPE !== "production", store: "agent", name: "workspace/sdk" },
    ),
);
